/**
 * RespiratoryTwinPage — „Дишане и кислород" (23-ият близнак, Respiratory гл. 42-50).
 * Един екран: картата с петте слоя + общият физиологичен слой между близнаците.
 * Данни: GET/POST /api/respiratory/*
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Wind } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";
import SEO from "@/components/SEO";
import PhysiologyBridgeCard from "@/components/PhysiologyBridgeCard";
import RespiratoryCard from "@/components/respiratory/RespiratoryCard";

import { MobileTopBar } from "@/components/MobileTopBar";
export default function RespiratoryTwinPage() {
  const { isDark } = useTheme();
  return (
    <div className={`min-h-screen ${isDark ? "bg-[hsl(222,47%,6%)] text-white" : "bg-[#F8FAFC] text-[#1A1A2E]"}`}
      data-testid="respiratory-twin-page">
      <MobileTopBar title="Дишане" fallbackTo="/dashboard" testid="respiratory-twin-mobile-topbar" />
      <SEO title="Дишане и кислород"
        description="Вентилация и механика, обструкция или рестрикция, газообмен и V/Q, реален пренос на кислород и контрол на дишането."
        path="/dashboard/respiratory-twin" />
      <div className="max-w-3xl mx-auto px-4 py-6">
        <Link to="/dashboard" className="inline-flex items-center gap-1 text-xs font-bold opacity-70 hover:opacity-100"
          data-testid="respiratory-back">
          <ArrowLeft className="w-3.5 h-3.5" /> Към таблото
        </Link>

        <h1 className="mt-3 text-2xl sm:text-3xl font-extrabold inline-flex items-center gap-2">
          <Wind className="w-6 h-6 text-sky-500" /> Дишане и кислород
        </h1>
        <p className="text-sm opacity-70 mt-1">
          Дишането е единствената автономна функция с волево управление — и
          единствената, при която три безплатни числа (задух, дихателна
          честота, задържане на дъха) показват резерва. Тук се събират
          механиката, проходимостта, газообменът, реалният пренос на кислород
          и това кой командва дишането.
        </p>

        <div className="mt-4">
          <RespiratoryCard isDark={isDark} />
        </div>

        <div className="mt-4">
          <PhysiologyBridgeCard focus="respiratory" isDark={isDark} />
        </div>
      </div>
    </div>
  );
}
